import {makeTrackEvent} from './makeTrackEvent';

export type PanelQuickAddAction =
  | 'Drawer opened'
  | 'Search box blurred'
  | 'Add bulk clicked'
  | 'Add one clicked';
export type PanelQuickAddScope = 'global' | 'section';
export type PanelQuickAddEvent = {
  action: PanelQuickAddAction;
  scope: PanelQuickAddScope;
  location?: string;
  isSearchActive?: boolean;
};

export const trackPanelQuickAdd = makeTrackEvent<
  PanelQuickAddEvent,
  {
    action: {
      description: 'what action took place';
    };
    scope: {
      description: 'whether user is adding globally or to a specific section';
      exampleValues: ['global', 'section'];
    };
    location: {
      description: 'where the action was triggered from';
    };
    isSearchActive: {
      description: 'whether a search query is present';
    };
    _description: 'Tracks events related to panel quick add';
    _location: 'workspaces';
    _motivation: 'new UI added, track usage';
  }
>('Panel quick add');
